export class LoginUserRequest {
    public email: string = "";
    public password: string = "";
}